"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWhitePianoKey = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const volumeChannels_1 = require("../../../volumeChannels");
const createWhitePianoKey = ({ audioPath, condition, inputCollectionID, isLabelVisible, onPlay, text, x, y, }) => {
    const inputPressHandlerIDs = [];
    const whitePianoKeyState = new pixel_pigeon_1.State({
        isPressed: false,
    });
    const spriteIDs = [];
    const buttonIDs = [];
    const labelIDs = [];
    const width = 10;
    const height = 48;
    spriteIDs.push((0, pixel_pigeon_1.createSprite)({
        animationID: () => whitePianoKeyState.values.isPressed ? "pressed" : "unpressed",
        animations: [
            {
                frames: [
                    {
                        height,
                        sourceHeight: height,
                        sourceWidth: width,
                        sourceX: 0,
                        sourceY: 0,
                        width,
                    },
                ],
                id: "unpressed",
            },
            {
                frames: [
                    {
                        height,
                        sourceHeight: height,
                        sourceWidth: width,
                        sourceX: width,
                        sourceY: 0,
                        width,
                    },
                ],
                id: "pressed",
            },
        ],
        coordinates: {
            condition,
            x,
            y,
        },
        imagePath: "piano-keys",
    }));
    buttonIDs.push((0, pixel_pigeon_1.createButton)({
        coordinates: {
            condition,
            x,
            y,
        },
        height,
        onMouseDown: () => {
            (0, pixel_pigeon_1.playAudioSource)(audioPath, {
                volumeChannelID: volumeChannels_1.sfxVolumeChannelID,
            });
            whitePianoKeyState.setValues({ isPressed: true });
            onPlay();
        },
        onRelease: () => {
            whitePianoKeyState.setValues({ isPressed: false });
        },
        width,
    }));
    inputPressHandlerIDs.push((0, pixel_pigeon_1.createInputPressHandler)({
        condition,
        inputCollectionID,
        onInput: () => {
            (0, pixel_pigeon_1.playAudioSource)(audioPath, {
                volumeChannelID: volumeChannels_1.sfxVolumeChannelID,
            });
            whitePianoKeyState.setValues({ isPressed: true });
            onPlay();
        },
        onRelease: () => {
            whitePianoKeyState.setValues({ isPressed: false });
        },
    }));
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.Black,
        coordinates: {
            condition: () => (typeof condition !== "undefined" ? condition() : true) &&
                (typeof isLabelVisible === "function"
                    ? isLabelVisible()
                    : isLabelVisible),
            x: x + 3,
            y: () => y + 28 + (whitePianoKeyState.values.isPressed ? 1 : 0),
        },
        horizontalAlignment: "left",
        text: {
            value: text,
        },
    }));
    return {
        buttonIDs,
        inputPressHandlerIDs,
        labelIDs,
        spriteIDs,
    };
};
exports.createWhitePianoKey = createWhitePianoKey;
